import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { useMutation, useQuery } from '@apollo/client';
import ApolloError from './../../shared/components/ApolloError';
import GET_USER_EMAIL_PREFERENCES from '../queries/getUserEmailPreferences';
import SET_USER_EMAIL_PREFERENCES from '../queries/setUserEmailPreferences';
import { useNavigate } from 'react-router-dom';

export const NewUserEmailPreferencesModal = () => {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const { data: userEmailPreferencesData, error: userEmailPreferencesError } = useQuery(
    GET_USER_EMAIL_PREFERENCES
  );

  const [setUserEmailPreferences, { error: setUserEmailPreferencesError }] = useMutation(
    SET_USER_EMAIL_PREFERENCES,
    { onError: () => {} }
    // Added OnError in order to test mutation error result. Related issue https://github.com/apollographql/apollo-client/issues/7167
  );

  useEffect(() => {
    if (!userEmailPreferencesData) {
      return;
    }

    setOpen(!userEmailPreferencesData.userEmailPreferences);
  }, [userEmailPreferencesData]);

  const handleClick = async optInForFutureAlerts => {
    await setUserEmailPreferences({
      variables: { optInForFutureAlerts: optInForFutureAlerts }
    });

    setOpen(false);

    if (!optInForFutureAlerts) {
      navigate('/account#email-preferences');
    }
  };

  if (userEmailPreferencesError) {
    return <ApolloError />;
  }

  return (
    <Dialog open={open} maxWidth='md' fullWidth>
      <div className='email-preferences-modal'>
        <DialogContent>
          {setUserEmailPreferencesError ? (
            <ApolloError />
          ) : (
            <>
              <DialogContentText>
                Welcome to the VIP Portal! The Portal can send you email notifications as data is
                updated. To receive these email notifications, click “Accept” below. To opt-out of
                email notifications, select “Update Preferences”
              </DialogContentText>
              <DialogActions>
                <button className='primary-button' onClick={() => handleClick(true)}>
                  Accept
                </button>
                <button className='primary-button' onClick={() => handleClick(false)}>
                  Update Preferences
                </button>
              </DialogActions>
            </>
          )}
        </DialogContent>
      </div>
    </Dialog>
  );
};

export default NewUserEmailPreferencesModal;
